import { render, staticRenderFns } from "./ExpensesPanel.vue?vue&type=template&id=22e4fc1a&scoped=true"
import script from "./ExpensesPanel.vue?vue&type=script&lang=js"
export * from "./ExpensesPanel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22e4fc1a",
  null
  
)

export default component.exports